import { render, staticRenderFns } from "./MacroSetting.vue?vue&type=template&id=b19851d4&scoped=true"
import script from "./MacroSetting.vue?vue&type=script&lang=js"
export * from "./MacroSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19851d4",
  null
  
)

export default component.exports